import { Flex, Skeleton } from 'antd'
import React from 'react'
import { OrganizationMemberFromContext } from '~/core/context/organization/hooks/useOrganizationMembers'
import { FeatureBlogPostClient } from '~/features/blogPost/client'
import { FeatureDriveFileClient } from '~/features/driveFile/client'
import { FeaturePostClient } from '~/features/post/client'
import { SupportClient } from '~/features/support/client'
import { FeatureTemplateClient } from '~/features/template/client'
import { UIChatMessageToken } from '../../types'

type PropsOne = {
  token: UIChatMessageToken
  organizationMember: OrganizationMemberFromContext
}

const RenderToken: React.FC<PropsOne> = ({ token, organizationMember }) => {
  switch (token.type) {
    case 'TICKET':
      return (
        <SupportClient.Thumbnail
          ticketId={token.id}
          organizationMember={organizationMember}
        />
      )
    case 'POST':
      return (
        <FeaturePostClient.Thumbnail
          postId={token.id}
          organizationMember={organizationMember}
        />
      )
    case 'FILE':
      if (organizationMember?.appSession?.app?.key === 'contentCreator') {
        return (
          <FeatureBlogPostClient.Thumbnail
            fileId={token.id}
            organizationMember={organizationMember}
          />
        )
      }
      if (organizationMember?.appSession?.app?.key === 'salesAssistant') {
        return (
          <FeatureTemplateClient.Thumbnail
            fileId={token.id}
            organizationMember={organizationMember}
          />
        )
      }
      return (
        <FeatureDriveFileClient.Thumbnail
          fileId={token.id}
          organizationMember={organizationMember}
        />
      )
    default:
      return null
  }
}

type PropsMany = {
  tokens: UIChatMessageToken[]
  organizationMember: OrganizationMemberFromContext
}

export const RenderTokens: React.FC<PropsMany> = ({
  tokens,
  organizationMember,
}) => {
  if (!organizationMember) {
    return (
      <Flex vertical>
        <Skeleton active paragraph={{ rows: 2 }} />
      </Flex>
    )
  }

  return (
    <Flex vertical>
      <Flex gap={20} wrap className="mt-4">
        {tokens.map((token, index) => (
          <RenderToken
            key={`${index}-${token.type ?? token.id}`}
            token={token}
            organizationMember={organizationMember}
          />
        ))}
      </Flex>
    </Flex>
  )
}
